export const RiveAnimationConfig = {
  checkMark: {
    fileName: 'checkmark-mdw',
    stateMachineName: 'Check-State-Machine',
    inputName: 'State',
    artboardName: 'Checkmark Artboard',
    states: {
      Unchecked: 0,
      Checked: 1,
      InitialChecked: 2,
    },
  },
  confetti: {
    fileName: 'confetti-mdw',
    stateMachineName: 'State Machine 1',
    inputName: 'isActive',
    artboardName: 'request-artboard',
    states: {
      Initial: 0,
      Active: 1,
    },
  },
  pipWalkingLight: {
    fileName: 'pip-walk-light-mdw',
    stateMachineName: 'Pip Light SM',
    inputName: 'isActive',
    artboardName: 'pip-walk-light',
    states: {
      NoWalk: 0,
      Walk: 1,
    },
  },
  pipWalkingDark: {
    fileName: 'pip-walk-dark-mdw',
    stateMachineName: 'Pip Dark SM',
    inputName: 'isActive',
    artboardName: 'pip-walk-dark',
    states: {
      NoWalk: 0,
      Walk: 1,
    },
  },
  spacesCustomizationLight: {
    fileName: 'spaces-customization-light',
    stateMachineName: 'sm-spaces-light',
    inputName: 'isActive',
    artboardName: 'spaces-light',
    states: {
      stop: 0,
      start: 1,
    },
  },
  spacesCustomizationDark: {
    fileName: 'spaces-customization-dark',
    stateMachineName: 'sm-spaces-dark',
    inputName: 'isActive',
    artboardName: 'spaces-dark',
    states: {
      stop: 0,
      start: 1,
    },
  },
  welcome: {
    fileName: 'welcome-people',
    stateMachineName: 'sm-welcome',
    inputName: 'isActive',
    artboardName: 'welcome-people',
    states: {
      Initial: 0,
      Active: 1,
    },
  },
  connectedSpacesLight: {
    fileName: 'connected-spaces-light',
    stateMachineName: 'sm-confetti-light',
    inputName: 'isActive',
    artboardName: 'confetti-light',
    states: {
      Initial: 0,
      Active: 1,
    },
  },
  connectedSpacesDark: {
    fileName: 'connected-spaces-dark',
    stateMachineName: 'sm-confetti-dark',
    inputName: 'isActive',
    artboardName: 'confetti-dark',
    states: {
      Initial: 0,
      Active: 1,
    },
  },
  messaging: {
    fileName: 'messaging',
    stateMachineName: 'sm-messaging',
    inputName: 'isActive',
    artboardName: 'messaging',
    states: {
      Initial: 0,
      Active: 1,
    },
  },
  downloadSpaces: {
    fileName: 'download-spaces',
    stateMachineName: 'sm-downloads',
    inputName: 'isActive',
    artboardName: 'downloads',
    states: {
      Initial: 0,
      Active: 1,
    },
  },
  typingDark: {
    fileName: 'typing-dark',
    stateMachineName: 'sm-typing-dark',
    inputName: 'isActive',
    artboardName: 'typing-dark',
    states: {
      Initial: 0,
      Active: 1,
    },
  },
  typingLight: {
    fileName: 'typing-light',
    stateMachineName: 'sm-typing-light',
    inputName: 'isActive',
    artboardName: 'typing-light',
    states: {
      Initial: 0,
      Active: 1,
    },
  },
};
